import config from "../config";

// Layouts
import { MainLayout } from "../layouts/MainLayout";

// Pages
// import Home from "../pages/Home";
import Menu from "../pages/Menu";

const publicRoutes = [
    // { path: config.routes.home, component: Home, layout: MainLayout },
    { path: config.routes.menu, component: Menu, layout: MainLayout },
]
  
const privateRoutes: any = [
    // { path: config.routes.admin, component: Admin, layout: AdminLayout },
]
  
export { publicRoutes, privateRoutes };
